export default __webpack_public_path__ + "static/Tone_of_Voice_7-e973bfdb6fcdba46ad4a27335fed1efb.svg";